import { createSelector } from '@reduxjs/toolkit';
import { selectFromMkadKm } from 'shared/selectors/jsonQuery';

export const selectFromMkadKmFilter = createSelector(selectFromMkadKm, ({ gte = null, lte = null }) => ({
  label: 'От МКАД',
  valueMin: gte,
  valueMax: lte,
  min: 0,
  max: 999,
}));
